import { useSyncExternalStore } from 'react';
import { sizes } from '@/constants/media';

const subscribe = (callback: () => void) => {
  window.addEventListener('resize', callback);
  return () => window.removeEventListener('resize', callback);
};

const getServerSnapshot = () => false;

export function useIsMobile(size = sizes.sm) {
  const getSnapshot = () => window.innerWidth < size;
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}